import { Button, Grid, TextField } from '@mui/material';
import { MprcBoxDrawer, MprcContainer } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

///////////////////////////////////////////////////////////////////////////////

export const RegistrationRemarksDrawer = (
    { subtitle, onClose }:
        {
            subtitle?: string | null,
            onClose: (remarks: string | null) => void;
        }
) => {
    const { t } = useTranslation("lms");
    const [remarks, setRemarks] = useState<string>("");

    return <MprcBoxDrawer
        onClose={() => onClose(null)}
        title={t("Registration.Remarks.Title")}
        subtitle={subtitle}
        content={
            <MprcContainer>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            autoFocus
                            fullWidth
                            rows={10}
                            multiline
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            placeholder={t("Registration.Remarks.RemarksPlaceholder")}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            variant="contained"
                            disabled={remarks == ""}
                            onClick={() => onClose(remarks)}
                        >
                            {t("Registration.Training.RequestRegisterButtonText")}
                        </Button>
                    </Grid>
                </Grid>
            </MprcContainer>
        }
    />;
};
